import Vue from 'vue'
import http from '../plugins/http'
import flits from '../plugins/flits'
import currency from './currency'
import icon from '@components/vgb-icon'
import jjVideo from '@components/jj-video'
import vgbModal from '@components/vgb-modal'

Vue.use(http)
Vue.use(flits)
Vue.use(vgbModal)

Vue.component('vgb-icon', icon)
Vue.component('jj-video', jjVideo)
Vue.filter('currency', currency)
Vue.config.devtools = process.env.NODE_ENV != 'production'

var __initialized = false

class Application {

    constructor(modules = {}) {

        if (! Array.isArray(modules)) {
            modules = [ modules ]
        }

        this.modules = modules
        this.run()

        __initialized = true
    }

    run() {
      if (typeof _state.cart === 'undefined') {
        _state.cart = {}
      }

      this.vm = new Vue({
        mixins: this.modules,
        data: {
          navIsActive: false,
          cartItemCount: (_state.cart.itemCount || 0),
          cartTotal: (_state.cart.total || 0),
        },
        computed: {
          navClass: function() {
            return (this.navIsActive ? 'active' : '')
          },
          cartIsVisible: function() {
            return this.cartItemCount > 0 &&
            location.pathname.indexOf('cart') === -1 &&
            location.pathname.indexOf('payment') === -1
          },
        },
        methods: {
          toggleNav: function() {
            this.navIsActive = ! this.navIsActive
          },
          gotoCart: function() {
            location.href = `${PUBLIC_PATH}cart/checkout`
          },
        }
      })

      if (DEBUG) {
        window.vuevm = this.vm
      }

      //
      // init app
      //
      this.vm.$mount('#app')
    }
}

export { Application as default }

//
// if app isn't started by a module, start it here
//
window.addEventListener('load', function() {
    if (! __initialized) {
        new Application
    }
});



// WEBPACK FOOTER //
// ./resources/assets/front/js/shared/application.js